const Client = () => import('./Client.vue')

const List = () => import('./pages/List.vue')
const Create = () => import('./pages/Create.vue')
const Edit = () => import('./pages/Edit.vue')

const routes = {
  component: Client,
  path: '/clientes',
  meta: {
    label: 'Clientes'
  },
  children: [
    {
      path: '',
      component: List,
      name: 'clientsList',
      meta: {
        label: 'Gerenciar Clientes',
        requiredPermission: {resource: 'client', value: 'view'}
      }
    },
    {
      path: 'cadastro',
      component: Create,
      name: 'clientCreate',
      meta: {
        hidden: true,
        label: 'Cadastrar',
        requiredPermission: {resource: 'client', value: 'manage'}
      }
    },
    {
      path: 'atualizar/:id',
      component: Edit,
      name: 'clientEdit',
      meta: {
        hidden: true,
        label: 'Atualizar',
        requiredPermission: {resource: 'client', value: 'manage'}
      }
    }
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/pages/client/routes.js